<template>
  <div>
    <h3>{{ title }}</h3>
    <p v-for="content in paragraphs"
       v-bind:key="content">
      <span v-html="content"></span>
    </p>
  </div>
</template>

<script>
export default {
  name: 'HeaderParagraph',
  props: {
    title: String,
    paragraphs: Array[String],
  },
};
</script>

<style scoped>

</style>
